import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const DeleteIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="smallIcon" clipPath="url(#clip0_988_8822)">
        <path
          id="Vector"
          d="M5.5 5.38281V3.88281C5.5 3.60667 5.72386 3.38281 6 3.38281H10C10.2761 3.38281 10.5 3.60667 10.5 3.88281V5.38281H13V6.38281H12V12.8828C12 13.159 11.7761 13.3828 11.5 13.3828H4.5C4.22386 13.3828 4 13.159 4 12.8828V6.38281H3V5.38281H5.5ZM6.5 4.38281V5.38281H9.5V4.38281H6.5Z"
          fill={fillColor || '#D4D5D5'}
        />
      </g>
      <defs>
        <clipPath id="clip0_988_8822">
          <rect width="16" height="16" fill={fillColor || 'white'} transform="translate(0 0.382812)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { DeleteIcon };
